import { Task } from '@bringg/types';
import _ from 'lodash';

function get(item: any, fallback: any, path: string) {
	let parent = item;
	const parts = path.split('.');
	let parentPath = path;

	if (parts[0] === 'lastWayPoint') {
		parent = item && _.last((item as Task).way_points);
		parts.shift();
		parentPath = parts.join('.');
	}

	if (!fallback) {
		return _.get(parent, parentPath);
	}

	return _.has(parent, parentPath) ? _.get(parent, parentPath) : get(fallback, undefined, path);
}

export const fieldValueGetter = { get };
